import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { putRegisterEmail } from '../../../api/login'
import { ReactComponent as Pencil } from '../../../assets/icons/pencil.svg'
import { useUserProfileStore } from '../../../stores/userProfileStore'
import { emailRegex } from '../../../utils/regexes'

import styles from './change-email.module.scss'

function ChangeEmail() {
    const { t } = useTranslation()

    const [{ userProfile }, { editMyProfileEmail }] = useUserProfileStore()
    const { email } = userProfile

    const [password, setPassword] = useState('')
    const [newEmail, setNewEmail] = useState('')

    const saveChanges = (e?: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault()

        if (!password || !newEmail) return

        if (!emailRegex.test(newEmail)) return

        putRegisterEmail(email, password, newEmail).then(() => {
            setPassword('')
            setNewEmail('')
            editMyProfileEmail(newEmail)
        })
    }

    return (
        <form className={styles.changeEmail} onSubmit={saveChanges}>
            <div className={styles.changeEmail__header}>
                <Pencil />
                {t('change_email')}
            </div>
            <div className={styles.changeEmail__label}>
                {t('old_email')}
                <div className={styles.changeEmail__input}>{email}</div>
            </div>
            <label className={styles.changeEmail__label} htmlFor="newEmail">
                {t('new_email')}
                <input
                    className={styles.changeEmail__input}
                    id="newEmail"
                    placeholder={t('new_email')}
                    name="newEmail"
                    type="text"
                    value={newEmail}
                    onChange={(e) => setNewEmail(e.target.value)}
                />
            </label>
            <label className={styles.changeEmail__label} htmlFor="oldPassword">
                {t('password')}
                <input
                    className={styles.changeEmail__input}
                    placeholder={t('password')}
                    id="oldPassword"
                    name="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </label>
            <button className={styles.changeEmail__btn} type="submit">
                {t('confirm')}
            </button>
        </form>
    )
}

export default ChangeEmail
